export const UploadSvg = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M68 48V68H12V48H4V68C4 70.1217 4.84285 72.1566 6.34315 73.6569C7.84344 75.1571 9.87827 76 12 76H68C70.1217 76 72.1566 75.1571 73.6569 73.6569C75.1571 72.1566 76 70.1217 76 68V48H68Z"
      fill="black"
    />
    <path d="M40 4L20 28H36V60H44V28H60L40 4Z" fill="black" />
  </svg>
);
